module.exports = __webpack_public_path__ + "static/WelcomeToElk8-2b26589f2a2e4cd26b12169257badb8f.png";